import {MutationTree} from 'vuex';
import {CallCenterUsersState} from './types';

export const mutations: MutationTree<CallCenterUsersState> = {
  pushCallCenterUsers(state, data) {
    state.callCenterUsers = state.callCenterUsers.concat(data);
  },
  setCallCenterUsers(state, data) {
    state.callCenterUsers = data;
  },
  setCallCenterUserItem(state, data) {
    state.callCenterUserItem = data;
  },
};
